import React from 'react';

import { ABBREVIATIONS_V2_TEXTS } from '../AbbreviationsSettingsV2.consts';

export const AbbreviationsHeader = (): React.ReactElement => (
  <div className="flex flex-col gap-1.5">
    <h2 className="text-xl font-semibold text-base-foreground">
      {ABBREVIATIONS_V2_TEXTS.HEADER_TITLE}
    </h2>
    <p className="text-base font-normal text-base-mutedForeground">
      {ABBREVIATIONS_V2_TEXTS.HEADER_DESCRIPTION}
    </p>
  </div>
);
